import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { BaseUrl } from "../../BaseUrl/BaseUrl";
import { Tooltip } from "@mui/material";
import { ServiceDiscounts } from "../../Components/enum";
import { LoaderContext } from "../../AuthContext/AuthContext";
import Batuk from "../../assets/images/new/fav-removebg-preview.png";
import PujaBookingBannerImg from "../../assets/images/new/PoojaBookingbannerImg.png";
import banner from '../../assets/images/new/orderPageBanner.png'
import placeholderImg from "../../assets/images/new/fav-removebg-preview.png";
import { t } from "i18next";
// import OrderDetails from "./OrderDetails";
const MyPanditBookingOrders = () => {
  const userID = JSON.parse(localStorage.getItem("userID"));
  const [orders, setOrders] = useState([]);
  const { setLoader, loader, selectedLanguageID } = useContext(LoaderContext);
  const navigate = useNavigate();
  useEffect(() => {
    setLoader(true);
    axios
      .post(`${BaseUrl}/Get_AllMyOrder?USER_ID=${userID}&TYPE=Pandit&LangID=${selectedLanguageID} `, {
        START: 1,
        END: 10,
        WORD: "None",
      })
      .then((response) => {

        setOrders(response.data.DATA);
        setLoader(false);
      });
  }, []);

  const SGST = 9;
  const CGST = 9;
  // const Tax = Math.round(((SGST + CGST) / 100) * Number(order.CONVENIENCE_FEE));

  const orderDetails = (myorders) => {
    navigate("/puja-Booking-order-details", { state: { order: myorders } });
  };

  function formatToIndianCurrency(amount) {
    if (!amount) return "";

    const [integerPart, decimalPart] = amount.toString().split(".");

    // Format the integer part using Indian numbering system
    const formattedIntegerPart = integerPart.replace(
      // Match groups of 3 digits initially, then groups of 2 digits
      /(\d)(?=(\d\d)+\d$)/g,
      "$1,"
    );

    // Return the formatted value with the decimal part (if present)
    return decimalPart !== undefined
      ? `${formattedIntegerPart}.${decimalPart}`
      : formattedIntegerPart;
  }



  const CalculateGrandTotal = (
    price,
    convenienceFee,
    needSamagri,
    samagriPrice,
    discount
  ) => {
    return (
      totalPrice(price, convenienceFee, needSamagri, samagriPrice, discount) +
      Math.round(
        (ServiceDiscounts.panditBookingDiscount / 100) *
        Number(
          totalPrice(
            price,
            convenienceFee,
            needSamagri,
            samagriPrice,
            discount
          )
        )
      )
    );
  };

  const totalPrice = (
    price,
    convenienceFee,
    needSamagri,
    samagriPrice,
    discount
  ) => {
    return (
      Number(price) +
      Number(convenienceFee) +
      (needSamagri === "yes" ? Number(samagriPrice) : 0) -
      discount
    );
  };

  return (
    <>
      <section className="page-header">
        <div className="page-header__bg" style={{ backgroundImage: `url(${PujaBookingBannerImg})` }}></div>
        <div className="container" >
          <h2 className="page-header__title bw-split-in-left">{t("Pandit Orders")}</h2>
        </div>
      </section>
      <div className="p-3 m-4 my-4">
        {orders?.length > 0 ? (
          <div className="row gx-4 gy-4" style={{ justifyContent: 'left' }}>
            {orders.map((order) => (
              <div className="col-xl-4 col-lg-4 col-md-6" key={order.id}>
                <div
                  className="card border-0 shadow-lg p-2 h-100"
                  onClick={() => orderDetails(order)}
                  style={{ cursor: "pointer" }}
                >
                  <div className="d-flex align-items-start">
                    <img
                      src={order?.PUJA_IMAGE || placeholderImg}
                      alt={order.PUJA_NAME}
                      className="rounded me-3"
                      style={{ width: "100px", height: "100px", objectFit: "contain" }}
                    />
                    <div>
                      <h6 className="mb-1 text-truncate" style={{
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                      }} title={order.PUJA_NAME}>
                        {order.PUJA_NAME}
                      </h6>
                      <span className="fw-bold text-muted">#{order.BookingID}</span>
                      {/* <p className="mb-1"><strong>Puja Date:</strong> {order.PB_DATE}</p> */}
                      <p className="mb-1"><strong>{t("Puja Type")}:</strong> {t(order.PoojaType || "Offline")}</p>
                      <p className="mb-1">
                        <strong>{t("Payment Status")}:</strong>{" "}
                        <span
                          style={{
                            color: order.PAYMENT_STATUS === "Pending" ? "red" : "green",
                            fontWeight: "600",
                          }}
                        >
                          {order.PAYMENT_STATUS === "Complete"
                            ? t("Completed")
                            : t(order.PAYMENT_STATUS)}

                        </span>
                      </p>
                      <p className="mb-1 fw-bold">
                        <strong>{t("Total Amount")}:</strong> ₹ {formatToIndianCurrency(order?.PB_GrandTotal)}
                      </p>
                      <button
                        className="Normal-app-btn ms-auto"
                        style={{
                          padding: "5px 10px",
                          fontSize: "12px",
                        }}
                      >
                        {t("View Details")}{" "}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : loader === false ? (
          <div className="d-flex flex-column align-items-center justify-content-center vh-90 text-center mt-4">
            <img
              src={Batuk}
              alt="Empty Cart"
              className="img-fluid mb-3"
              style={{ maxWidth: "250px" }}
            />
            <h5 className="fw-bold">{t("No orders found")}</h5>
            <button
              className="careox-btn"
              style={{ cursor: "pointer" }}
              onClick={() => navigate("/services/puja-booking")}
            >
              {t("Book now")}
            </button>
          </div>
        ) : (
          ""
        )}
      </div>



    </>

  );
};

export default MyPanditBookingOrders;
